import { Navigate } from 'react-router-dom';

import Typography from '@mui/material/Typography';

import { useData } from '../../contextProviders/DataProvider';

import Hourglass from './Hourglass';

interface PrivateRouteProps {
  children: React.ReactNode;
  conditionForAltChildren?: () => boolean;
  altChildren?: React.ReactNode;
}

export default function PrivateRoute(props: PrivateRouteProps) {
  const { children, conditionForAltChildren = () => false, altChildren = null } = props;
  const { userState } = useData();

  if (
    userState.status === 'authenticating_user' ||
    userState.status === 'authenticating_profile' ||
    userState.status === 'authenticating_memberships'
  ) {
    return <Hourglass />;
  }

  if (userState.status === 'logged_out') {
    return <Navigate to="/login" />;
  }

  if (userState.status === 'error') {
    return (
      <Typography variant="headlineSmall" sx={{ p: 2 }}>
        Error: Your profile failed to load. Please try again later.
      </Typography>
    );
  }

  if (conditionForAltChildren() && altChildren) {
    return altChildren;
  }

  return children;
}
